module.exports = __webpack_public_path__ + "static/img/honor-5.b486eeb.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/landing/honor-5.png
// module id = 3MPU
// module chunks = 0